/**
 * Ant Select dropdown renderer with a Create * row above the options.
 *
 * @param {string} label Create label without the leading plus.
 * @param {function(): void} onCreate Click handler for the create row.
 * @return {function(*): *}
 */
export const createPopupRender = (label, onCreate) => menu => (
  <>
    <div
      role="button"
      tabIndex={0}
      style={{
        padding: "8px 12px",
        cursor: "pointer",
        color: "#2060EA",
        borderBottom: "1px solid #e9edf5",
      }}
      onMouseDown={event => event.preventDefault()}
      onClick={onCreate}
      onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onCreate();
        }
      }}
    >
      + {label}
    </div>
    {menu}
  </>
);
